import localize from '../../../../common/localize';
import ReportSectionTitle from '../../../../components/common/ReportSectionTitle';
import TableComponentForReport from './TableComponentForReports';
import ValueOrNoDataLabel from '../../../../components/common/ValueOrNoDataLabel';

export default function ReportEventResolutions({ resolutions }) {
  return (
    <div>
      <ReportSectionTitle title={localize.resolutions} />
      <div className="report_section_without_top_border">
        {resolutions?.length > 0 ? (
          <TableComponentForReport
            headers={[localize.code, localize.resolution, localize.description]}
            rows={resolutions.map((resolution) => [
              <ValueOrNoDataLabel
                data={resolution?.Resolution?.Code}
                hideBackground
                centerValue
              />,
              <ValueOrNoDataLabel
                data={resolution?.Resolution?.Name}
                hideBackground
                centerValue
              />,
              <ValueOrNoDataLabel
                data={resolution?.Resolution?.Description}
                hideBackground
                centerValue
              />,
            ])}
          />
        ) : (
          <label className="report_little_text">{localize.no_data}</label>
        )}
      </div>
    </div>
  );
}
